"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var common_hooks_1 = require("@l2p/common-hooks");
var swr_hooks_1 = require("@l2p/swr-hooks");
var react_1 = __importStar(require("react"));
var SearchGamesDropdown_1 = __importDefault(require("./SearchGamesDropdown"));
var SearchInput_1 = require("./SearchInput");
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var SearchByValue = function (_a) {
    var _b;
    var gameCardPlaceholder = _a.gameCardPlaceholder, _c = _a.isShowPlaceholder, isShowPlaceholder = _c === void 0 ? true : _c;
    var wrapperRef = (0, react_1.useRef)(null);
    var _d = (0, react_1.useState)(false), isFocus = _d[0], setIsFocus = _d[1];
    var _e = (0, react_1.useState)(null), provider = _e[0], setProvider = _e[1];
    (0, common_hooks_1.useOnClickOutside)(wrapperRef, function () { return setIsFocus(false); });
    var _f = (0, swr_hooks_1.useSearchGamesByFilters)({
        showCount: 10,
        providerId: (provider === null || provider === void 0 ? void 0 : provider.id) || null,
    }), data = _f.data, searchGamesToShow = _f.gamesToShow, searchValue = _f.searchValue, onLoadBtnClick = _f.onLoadBtnClick, onFiltersClear = _f.onFiltersClear, onSearchChange = _f.onSearchChange;
    var isShowMore = (((_b = data === null || data === void 0 ? void 0 : data.data) === null || _b === void 0 ? void 0 : _b.totalCount) || 0) > ((searchGamesToShow === null || searchGamesToShow === void 0 ? void 0 : searchGamesToShow.length) || 0);
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.wrapper, ref: wrapperRef },
        react_1.default.createElement("div", null,
            react_1.default.createElement("div", { className: styles_module_scss_1.default.searchFieldsWrapper },
                react_1.default.createElement(SearchInput_1.SearchInput, { value: searchValue, onClear: function () {
                        setProvider(null);
                        onFiltersClear();
                    }, onFocus: function () { return setIsFocus(true); }, onChange: onSearchChange }),
                searchValue || isFocus
                    ? (isShowPlaceholder || (searchGamesToShow === null || searchGamesToShow === void 0 ? void 0 : searchGamesToShow.length)) && (react_1.default.createElement(SearchGamesDropdown_1.default, { searchValue: searchValue, games: searchGamesToShow, gameCardPlaceholder: gameCardPlaceholder, isShowMore: isShowMore, onLoadBtnClick: onLoadBtnClick, provider: provider, setProvider: setProvider }))
                    : null))));
};
exports.default = SearchByValue;
